<template>
  <v-layout align-center justify-center>
    <v-autocomplete id="selectIcons"
      v-model="icon"
      hide-details="auto"
      cache-items
      required
      :class="'my-3'"
      :key="icon"
      :items="icons"
      :no-data-text="'Nenhum ícone encontrado...'"
      :label="'Ícone'"
      :prepend-icon="icon"
    >
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <v-icon>{{item}}</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>{{item}}</v-list-item-title>
      </template>
    </v-autocomplete>

    <v-fade-transition>
      <v-btn class="ml-2 mr-2" dark color="disabled" v-show="shouldShow" @click="didTapRevert">
        <v-icon>undo</v-icon>
      </v-btn>
    </v-fade-transition>

    <v-fade-transition>
      <v-btn color="primary" v-show="shouldShow" @click="didTapSave">Salvar</v-btn>
    </v-fade-transition>
  </v-layout>
</template>

<script>
import icons from "@/utils/icons.js";

export default {
  props: {
    chapter: { type: Object, required: true }
  },

  mounted() {
    const defaultIcon = "insert_drive_file";
    if (!this.chapter.icon) this.chapter.icon = defaultIcon;
    this.icon = this.chapter.icon;
  },

  data: () => ({
    icons,
    icon: ""
  }),

  computed: {
    shouldShow() {
      const downloadHasFinished = this.icon && this.chapter.icon;
      const iconHasChanged = this.icon !== this.chapter.icon;
      return downloadHasFinished ? iconHasChanged : false;
    }
  },

  methods: {
    didTapRevert() {
      this.icon = this.chapter.icon;
    },

    didTapSave() {
      this.$emit("didTapSave", this.icon);
    }
  }
};
</script>